import Modal from "../../../components/Modal";
import { TextInput } from "../../../components/TextInput";
import { useUser } from "../../../services/user-context";

export function EditProfileModal({
  onClose,
  isOpen,
}: {
  onClose: () => void;
  isOpen: boolean;
}) {
  const { userInfo } = useUser() as any;

  return (
    <Modal
      contentClassName="!px-0"
      title="Profile"
      isOpen={isOpen}
      handleModal={onClose}
    >
      <div className="max-h-[calc(100vh-125px)] overflow-auto">
        <div className="flex mt-[26px] px-5 flex-col gap-4">
          <div className="flex items-center gap-4">
            <div className="flex-1 flex flex-col gap-1.5">
              <label className="text-sm text-text-primary/80">
                First Name
              </label>
              <TextInput
                placeholder="First name"
                type="text"
                name="firstName"
                value={userInfo?.firstName ?? ""}
                disabled
              />
            </div>
            <div className="flex-1 flex flex-col gap-1.5">
              <label className="text-sm text-text-primary/80">
                Last Name
              </label>
              <TextInput
                placeholder="Last name"
                type="text"
                name="lastName"
                value={userInfo?.lastName ?? ""}
                disabled
              />
            </div>
          </div>
          <div className="mb-4 flex flex-col gap-1.5">
            <label className="text-sm text-text-primary/80">
              Email
            </label>
            <TextInput
              placeholder="Email address"
              type="email"
              name="email"
              value={userInfo?.email ?? ""}
              disabled
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
